// import { create } from "zustand";
// import axios from "../lib/axios.js";

// export const useImageStore = create((set, get) => ({

//   imagesByCategory: {},
//   categoryImages: {},

//   getImagesByCategory: async (category) => {
//     try {
    
//       const response = await axios.get(`/images/category/${category}`);

//       set((state) => ({
//         imagesByCategory: {
//           ...state.imagesByCategory,
//           [category]: response.data.images,
//         },
//       }));
//     } catch (error) {
//       console.log(category)
//       console.error("Error fetching images by category:", error.message);
//     }
//   },
//   getImages: async () => {
//     try {
//       const response = await axios.get("/images");
//       set({ categoryImages: response.data.images });
//       console.log(response.data.images);
//     } catch (error) {
//       console.error("Error fetching images:", error.message);
//     }
//   },
// }));


import { create } from "zustand";
import axios from "../lib/axios.js";

export const useImageStore = create((set) => ({
  imagesByCategory: {},

  getImagesByCategory: async (category) => {
    try {
      const response = await axios.get(`/images/category/${category}`);

      set((state) => ({
        imagesByCategory: {
          ...(state.imagesByCategory || {}),
          [category]: response.data.images || [],
        },
      }));
    } catch (error) {
      console.warn(`No images found for category: ${category}`);

      // IMPORTANT: always initialize category as empty array
      set((state) => ({
        imagesByCategory: {
          ...(state.imagesByCategory || {}),
          [category]: [],
        },
      }));
    }
  },
}));
